import { render } from "./EquippedItemsModal.vue?vue&type=template&id=7c011363&scoped=true"
import script from "./EquippedItemsModal.vue?vue&type=script&lang=js"
export * from "./EquippedItemsModal.vue?vue&type=script&lang=js"

import "./EquippedItemsModal.vue?vue&type=style&index=0&id=7c011363&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c011363"]])

export default __exports__